import { Controller } from 'stimulus'
import { displayTags } from 'components/tags_select'

export default class extends Controller {
  displayTags = displayTags
}
